// project import
import dashboard from './dashboard';
import clients from './clients';
import talentDiscovery from './talent-discovery';
import testingResults from './testing-results';
import generativeAI from './generative-ai';
import settings from './settings';

// ==============================|| MENU ITEMS ||============================== //
const menuItems = {
  items: [dashboard, clients, talentDiscovery, testingResults, generativeAI, settings]
};

export default menuItems;
